export default __webpack_public_path__ + "static/water-desk-dba95dfbaf44f44ad8d3f81f1565cdab.gif";